import { render } from "./ShortAnswer.vue?vue&type=template&id=7d149581"
import script from "./ShortAnswer.vue?vue&type=script&lang=js"
export * from "./ShortAnswer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__